'use client'

import { useMemo, useState } from 'react'

import { AccordionContext } from './accordion-context'

export const AccordionProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [currentIndex, setCurrentIndex] = useState<number>()
  const value = useMemo(
    () => ({
      currentIndex,
      setCurrentIndex,
    }),
    [currentIndex]
  )

  return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>
}
